import { Themes } from '../types';

import { recipes } from './recipes';
import { tokens } from './tokens';

export const darkTheme = {
  name: Themes.Dark,
  tokens,
  recipes,
};
